/**
 * Canonical TanStack Query keys.
 * Values match existing legacy keys so current invalidateQueries keep working.
 */
export const queryKeys = {
  agents: {
    all: ['get-all-agents'],
    feeda: ['get-feeda-agents'],
    detail: id => (id ? ['get-single-agent', id] : ['get-single-agent']),
    ofUser: userId => ['agents-of-user', userId],
  },
  models: {
    all: ['get-all-models'],
  },
  teams: {
    all: ['teams'],
    admin: searchQuery => ['admin_teams', searchQuery],
    allAlias: ['get-all-teams'],
  },
  tools: {
    all: ['list'],
    admin: ['admin_list'],
  },
  skills: {
    all: ['skills-list'],
  },
  projects: {
    all: ['get_all_projects'],
  },
  workflows: {
    all: ['get_all_workflows'],
    detail: id => ['get-workflow-details', id],
  },
  sessions: {
    root: ['sessions'],
    sidebar: payload => ['sessions', 'sidebar_sessions', payload],
  },
};

/** Prefix used to invalidate all session queries (sidebar + related). */
export const sessionsInvalidateKey = queryKeys.sessions.root;
